"use strict";
import TOPAZ_LOGO from "assets/images/logo.png";
import { usePrivyAuth } from "components/Web3Provider/privy/PrivyWagmiBridge";
import { TopazIdModal } from "components/Web3Provider/privy/TopazIdModal";
import { useState } from "react";
import { Flex, Text } from "ui/src";
import { iconSizes } from "ui/src/theme";
export function PrivyLoginOptions({ onDone }) {
  const privyAuth = usePrivyAuth();
  const [modalOpen, setModalOpen] = useState(false);
  if (!privyAuth) {
    return null;
  }
  return <>
      <Flex
    backgroundColor="$surface2"
    row
    alignItems="center"
    width="100%"
    justifyContent="space-between"
    px="$spacing12"
    py="$spacing18"
    cursor="pointer"
    hoverStyle={{ backgroundColor: "$surface1Hovered" }}
    onPress={() => setModalOpen(true)}
  >
        <Flex row alignItems="center" gap="$gap12">
          <img
    src={TOPAZ_LOGO}
    alt="Topaz ID"
    width={iconSizes.icon40}
    height={iconSizes.icon40}
    style={{ borderRadius: 8, objectFit: "contain" }}
  />
          <Text variant="body2">Topaz ID</Text>
        </Flex>
        <Text variant="body4" color="$neutral3">
          Email or Google
        </Text>
      </Flex>

      <TopazIdModal isOpen={modalOpen} onClose={() => setModalOpen(false)} onDone={() => onDone?.()} />
    </>;
}
